<img class="avatar" [src]="src" alt="Image-with-loader" [ngStyle]="{ visibility: imageloading? 'hidden' : '', 
        height: height > 0 ? height + unit: 'auto',
        width: width > 0 ? width + unit: 'auto'}"
    [ngClass]="{'square-border': !rounded, 'transparent-background': transparentBackground}" (load)="hideLoader()"
    (error)="hideLoader()" />
<div class="fix-loader" *ngIf="imageloading" [ngStyle]="{height: '100%',width: width > 0 ? width + unit: 'auto'}">
    <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>